<!-- <form class="dynamic-form" [formGroup]="form" (change)="onSubmit($event)" (submit)="onSubmit($event)"> -->
<form class="dynamic-form" [formGroup]="form">
  <span *ngFor="let field of fields;" dynamicField [field]="field" [group]="form">
  </span>
</form>
